<template>
  <div v-if="!isLoading && (!hasList)" class="vod-list-empty">
    <img src="../../../assets/images/common/icon-error-74.png" alt="error">
    <p>하이라이트 영상이 없습니다.</p>
  </div>
  <div v-else-if="!isLoading && hasList" class="player-component01">
    <div id="all" class="player-list">
      <thumb-all-highlight v-for="(highlight, index) in highlightList" :key="index" :cell-info="highlight" :current-content-id="currentContentId"/>
    </div>
    <paging-component :current-page="currentPage"
                      :page-count="pageCount"
                      :limit="limit"
                      :paging-count="10"
                      :is-next-button-view="isNextButtonView"
    />
  </div>
</template>

<script>
  import _ from 'lodash'
  import { getHighlightPlayerList } from '@/common/utils/request'
  import PagingComponent from '@/components/common/PagingComponent'
  import ThumbAllHighlight from '@/components/player/baseball/ThumbAllHightlight'
  import axios from 'axios'
  export default {
    name: 'HighlightRecommend',
    components: {
      ThumbAllHighlight,
      PagingComponent
    },
    props: {
      currentContentId: {
        type: String
      }
    },
    data () {
      return {
        highlightList: [],
        currentPage: 1,
        pageCount: 0,
        limit: 10,
        isNextButtonView: false,
        isLoading: true
      }
    },
    computed: {
      hasList () {
        return this.highlightList.length > 0
      }
    },
    methods: {
      async fetchData () {
        try {
          const offset = this.limit * (this.currentPage - 1)
          const nextHighlightInfo = getHighlightPlayerList({ offset: Math.ceil(this.currentPage / 10) * 100, limit: this.limit })
          const highlightInfo = getHighlightPlayerList({ offset, limit: this.limit })
          return await axios.all([nextHighlightInfo, highlightInfo])
        } catch (e) {
          console.log(e)
        }
      },
      setData (responseList) {
        this.highlightList = _.get(responseList, '1.data.cell_toplist.celllist', [])
        this.pageCount = _.get(responseList, '1.data.cell_toplist.pagecount', 0)
        this.isNextButtonView = _.get(responseList, '0.data.cell_toplist.celllist', []).length > 0
      },
      async init () {
        this.isLoading = true
        const response = await this.fetchData()
        this.setData(response)
        this.isLoading = false
      }
    },
    created () {
      this.currentPage = Number(_.get(this.$route, 'query.page', 1))
      this.init()
    }
  }
</script>
<style scoped>
 .vod-list-empty img {
  width: 74px;
 }
</style>
